// frontend/src/pages/ThumbnailWorkspace.tsx


import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import ThumbnailWorkspace from '../components/ThumbnailWorkspace';
import { api } from '../lib/api';

type Tale = {
  id: string;
  title: string;
  status: string;
  verse_ref: string | null;
  content?: any;
};

export default function ThumbnailWorkspacePage() {
  const { id } = useParams();
  const nav = useNavigate();
  const [tale, setTale] = useState<Tale | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    
    api(`/api/tales/${id}/detail`)
      .then((data: any) => {
        // The getTaleDetail endpoint returns the tale data directly
        setTale(data);
        setLoading(false);
      })
      .catch((err: any) => {
        console.error('Failed to load tale:', err);
        // If it's a reauth error, redirect to login
        if (err.message === 'reauth_required') {
          window.location.href = '/login';
          return;
        }
        setLoading(false);
      });
  }, [id]);

  if (loading) return <div className="min-h-screen grid place-items-center text-zinc-400">Loading…</div>;
  if (!tale)   return <div className="min-h-screen grid place-items-center text-red-400">Tale not found</div>;

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="px-6 py-4 border-b">
        <div className="flex items-center gap-3">
          <h1 className="text-xl font-semibold">Thumbnail Workspace</h1>
          <span className="text-sm text-muted-foreground">{tale.title}</span>
          <button onClick={() => window.location.assign(`/tales/${tale.id}`)} className="ml-auto px-4 py-2 rounded border border-border hover:bg-accent text-sm">Close</button>
        </div>
      </div>

      <div className="p-6">
        <ThumbnailWorkspace
          taleId={tale.id}
          title={tale.title}
          topic="Bible Story"
          audience="Families"
          maxVariants={3}
        />
      </div>
    </div>
  );
}
